const emptyUserResponse = {
    results: [],
    pagination: {
        total: 0,
        num_pages: 0,
        page: 0,
        numPages: 0
    },
}

const state = {
    users: {...emptyUserResponse},
    impersonator: null,
}


export const getters = {
    isImpersonating: state => state.impersonator !== null,
    impersonator: state => state.impersonator,
}


export const mutations = {
    resetImpersonator(state) {
        state.impersonator = null
    },
    rememberImpersonator(state, {token, type}) {
        state.impersonator = {
            token: token,
            type: type,
        }
    },
}


export const actions = impersonateService => ({
    async fetchUsersList({commit}, {filters, pagination, sorting}) {
        return await impersonateService.fetchUsersList(filters, pagination, sorting)
    },
    async impersonate({commit, dispatch, rootGetters}, user) {
        const response = await impersonateService.impersonate(user.id)

        commit('rememberImpersonator', {
            token: rootGetters['auth/token'],
            type: rootGetters['auth/tokenType'],
        })

        commit('auth/SET_TOKEN', {
            token: response.token,
            token_type: 'Token',
            remember: false,
        }, {root: true})

        dispatch('auth/getCurrentUser',false, {root: true})
    },
    async returnYourself({commit, getters, dispatch}) {
        const impersonator = getters.impersonator

        console.log('set token', impersonator)
        commit('auth/SET_TOKEN', {
            token: impersonator.token,
            token_type: impersonator.type,
            remember: true,
        }, {root: true})

        dispatch('auth/getCurrentUser', true, {root: true})

        commit('resetImpersonator')
    }
})

export default impersonateService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(impersonateService)
})

